export enum StatusGPS {
  PARADO="PARADO",
  PAUSADO="PAUSADO",
  ATIVO="ATIVO"
}
